import type { App } from "@open-booking/server";
import type { CreateOwnerDocumentPayload } from "@open-booking/shared";
import { createApi } from "@reduxjs/toolkit/query/react";
import { type EdenCall, edenBaseQuery } from "@/src/common/lib/eden-base-query";

type ListOwnerDocumentsResponse = App["~Routes"]["owner-documents"]["get"]["response"]["200"];
type CreateOwnerDocumentResponse = App["~Routes"]["owner-documents"]["post"]["response"]["200"];
type DeleteOwnerDocumentResponse = App["~Routes"]["owner-documents"][":id"]["delete"]["response"]["200"];

export const ownerDocumentApi = createApi({
	reducerPath: "ownerDocumentApi",
	baseQuery: edenBaseQuery(),
	tagTypes: ["OwnerDocument"],
	endpoints: (builder) => ({
		listOwnerDocuments: builder.query<ListOwnerDocumentsResponse, void>({
			query: (): EdenCall<ListOwnerDocumentsResponse> => (client) => client["owner-documents"].get(),
			providesTags: ["OwnerDocument"],
		}),
		createOwnerDocument: builder.mutation<CreateOwnerDocumentResponse, CreateOwnerDocumentPayload>({
			query:
				(payload): EdenCall<CreateOwnerDocumentResponse> =>
				(client) =>
					client["owner-documents"].post(payload),
			invalidatesTags: ["OwnerDocument"],
		}),
		deleteOwnerDocument: builder.mutation<DeleteOwnerDocumentResponse, string>({
			query:
				(id): EdenCall<DeleteOwnerDocumentResponse> =>
				(client) =>
					client["owner-documents"]({ id }).delete(),
			invalidatesTags: ["OwnerDocument"],
		}),
	}),
});

export const { useListOwnerDocumentsQuery, useCreateOwnerDocumentMutation, useDeleteOwnerDocumentMutation } = ownerDocumentApi;
